// 语言包，英文(美国)
export default {
    age: "age",

    cancelData: "cancel",
    changeLanguage: "change language",
    changePassword: "change your password",
    changeRole: "change role",
    closeAllTabs: "close all",
    closeLeftTabs: "close left",
    closeOtherTabs: "close others",
    closeRightTabs: "close right",
    confirmData: "confirm",
    customerDetail: "customer detail",
    customerList: "customer list",
    customerManage: "customer manage",
    customerMobile: "customer mobile",
    customerName: "customer name",

    gender: "gender",

    helps: "help me",
    home: "home",

    indexName: "index",

    logout: "logout",
    languageName: "language",

    muchMoreTabs: "you hav opened much more tabs, please close some of them and try again",

    notice: "notice",

    operation: "options",
    orderAmount: "order amount",
    orderDate: "order date",
    orderDetail: "order detail",
    orderList: "order list",
    orderManage: "order manage",
    orderStatus: "order status",

    payee: "payee",

    requiredUserName: "user name can not be null",
    returnHome: "return home",
    refreshPage: "refresh",
    reviewer: "reviewer",

    saveChange: "save changes",
    setColumnName: "set column name",
    stockName: "stock name",

    toDetail: "detail",

    userName: "user name",
    userInfo: "user profiles",

    viewVersion: "view version",
}